import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["keyword", "type", "maxGaps", "n", "o"],
  _excluded2 = ["keyword"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, watch } from 'vue';
import SearchTabs from '@/components/renewal/header/search/search-tabs.vue';
import SearchForm from '@/components/renewal/header/search/search-form.vue';
import BookPanel from '@/components/renewal/header/search/filter/keyword/book-panel.vue';
import GuidelinePanel from '@/components/renewal/header/search/filter/keyword/guideline-panel.vue';
import PublicCommentPanel from '@/components/renewal/header/search/filter/keyword/public-comment-panel.vue';
import LawPanel from '@/components/renewal/header/search/filter/keyword/law-panel.vue';
import WandhPanel from '@/components/renewal/header/search/filter/wandh/wandh-panel.vue';
import SearchFooter from '@/components/renewal/header/search/search-footer.vue';
import AgreementDialog from '@/components/renewal/header/agreement-dialog.vue';
import { useToast } from '@/plugins/vueToast';
import { useRepositories } from '@/plugins/repositories';
import { useStore } from '@/store/useStore';
import { useTelemetry } from '@/plugins/telemetry';
import { RateLimitError, QuotaExceededError } from 'wklr-backend-sdk/errors';
import { WandhAvailableBooks } from 'wklr-shared/dist/constants';
import { DocumentTypeEnum } from 'wklr-backend-sdk/models';
import * as Constants from '@/constants';
import { generateSearchRoute } from '@/utils/routeUtils';
import { scrollToTop } from '@/utility';
import { debounce } from 'throttle-debounce';
export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  emits: ['changeVariant'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var toast = useToast();
    var isSearching = ref(false);
    var repositories = useRepositories();
    var store = useStore();
    var telemetry = useTelemetry();
    var route = useRoute();
    var router = useRouter();
    var type = ref('keyword');
    var docType = ref('book');
    var isCollapsed = ref(true);
    var showFilter = ref(false);
    var showAgreementDialog = ref(false);
    var searchForm = ref();
    var wandhPanel = ref();
    var agreementDialog = ref(null);
    var inputSearchKeyword = computed({
      get: function get() {
        return store.state.searchBox.keyword;
      },
      set: function set(newVal) {
        if (newVal === null || newVal === store.state.searchBox.keyword) return;
        store.commit('setSearchKeyword', newVal);
      }
    });
    var isChangedFilterQuery = function isChangedFilterQuery(query) {
      var _defaultFilterQuery$t;
      var _keyword = query.keyword,
        type = query.type,
        maxGaps = query.maxGaps,
        n = query.n,
        o = query.o,
        filterQuery = _objectWithoutProperties(query, _excluded);
      var defaultFilterQuery = {
        type: [DocumentTypeEnum.Book],
        maxGaps: Constants.Search.DefaultMaxGaps,
        n: Constants.Search.PerPage,
        o: Constants.Search.OrderId
      };
      if (((_defaultFilterQuery$t = defaultFilterQuery.type) === null || _defaultFilterQuery$t === void 0 ? void 0 : _defaultFilterQuery$t[0]) !== (type === null || type === void 0 ? void 0 : type[0]) || defaultFilterQuery.maxGaps !== maxGaps || defaultFilterQuery.n !== n || defaultFilterQuery.o !== o) {
        return true;
      }
      if (Object.keys(filterQuery).length > 0) {
        return true;
      }
      return false;
    };
    var storedQuery = computed(function () {
      return store.state.search.query;
    });
    var toSearchDocType = function toSearchDocType(type) {
      switch (type) {
        case DocumentTypeEnum.Book:
          return 'book';
        case DocumentTypeEnum.Guideline:
          return 'guideline';
        case DocumentTypeEnum.Pubcom:
          return 'public-comment';
        case DocumentTypeEnum.Law:
          return 'law';
        default:
          return 'book';
      }
    };
    watch(storedQuery, function (newVal) {
      var _newVal$type$, _newVal$type;
      docType.value = toSearchDocType((_newVal$type$ = (_newVal$type = newVal.type) === null || _newVal$type === void 0 ? void 0 : _newVal$type[0]) !== null && _newVal$type$ !== void 0 ? _newVal$type$ : 'book');
    }, {
      immediate: true
    });
    watch(type, function (newVal) {
      if (newVal === 'wandh') {
        var _agreementDialog$valu;
        (_agreementDialog$valu = agreementDialog.value) === null || _agreementDialog$valu === void 0 ? void 0 : _agreementDialog$valu.checkAgreement();
      }
    });
    watch(inputSearchKeyword, function (newVal) {
      if (type.value === 'keyword') {
        debouncedFetchSuggestions(newVal);
      }
    });

    // 詳細検索の条件が変更されている場合は詳細検索フォームを表示
    onBeforeMount(function () {
      var _storedQuery$value$ty, _storedQuery$value$ma, _store$state$persiste, _store$state$search$o;
      var filterQuery = _objectSpread(_objectSpread({}, storedQuery.value), {}, {
        type: (_storedQuery$value$ty = storedQuery.value.type) !== null && _storedQuery$value$ty !== void 0 ? _storedQuery$value$ty : [DocumentTypeEnum.Book],
        maxGaps: (_storedQuery$value$ma = storedQuery.value.maxGaps) !== null && _storedQuery$value$ma !== void 0 ? _storedQuery$value$ma : Constants.Search.DefaultMaxGaps,
        n: (_store$state$persiste = store.state.persistent.perPage) !== null && _store$state$persiste !== void 0 ? _store$state$persiste : Constants.Search.PerPage,
        o: (_store$state$search$o = store.state.search.orderId) !== null && _store$state$search$o !== void 0 ? _store$state$search$o : Constants.Search.OrderId
      });
      showFilter.value = isChangedFilterQuery(filterQuery);
    });
    var fetchSuggestions = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(keyword) {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(keyword === null || keyword.length <= 1)) {
                _context.n = 1;
                break;
              }
              // 1文字以下の時はサジェストを出さない
              store.commit('setSuggestionItems', []);
              _context.n = 3;
              break;
            case 1:
              _context.n = 2;
              return repositories.searches.getCompleteSearch(keyword);
            case 2:
              res = _context.v;
              store.commit('setSuggestionItems', res);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function fetchSuggestions(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var debouncedFetchSuggestions = debounce(500, fetchSuggestions);
    var handleClickSuggestion = function handleClickSuggestion(item) {
      inputSearchKeyword.value = item;
      submit();
    };
    var suggestionItems = computed(function () {
      return store.state.search.suggestionItems.filter(function (item) {
        return item !== inputSearchKeyword.value;
      });
    });
    var handleChangeType = function handleChangeType(newVal) {
      type.value = newVal;
      isCollapsed.value = false;
    };
    var handleChangeShowFilter = function handleChangeShowFilter(newVal) {
      isCollapsed.value = false;
      showFilter.value = newVal;
    };
    var handleChangeDocType = function handleChangeDocType(newVal) {
      docType.value = newVal;
    };
    var handleShowDisclaimer = function handleShowDisclaimer() {
      showAgreementDialog.value = true;
    };
    var bookQuery = ref({
      type: [DocumentTypeEnum.Book]
    });
    var guidelineQuery = ref({
      type: [DocumentTypeEnum.Guideline]
    });
    var publicCommentQuery = ref({
      type: [DocumentTypeEnum.Pubcom]
    });
    var lawQuery = ref({
      type: [DocumentTypeEnum.Law]
    });
    var clonedQuery = computed({
      get: function get() {
        switch (docType.value) {
          case 'book':
            return bookQuery.value;
          case 'guideline':
            return guidelineQuery.value;
          case 'public-comment':
            return publicCommentQuery.value;
          case 'law':
            return lawQuery.value;
          default:
            return bookQuery.value;
        }
      },
      set: function set(newVal) {
        switch (docType.value) {
          case 'book':
            bookQuery.value = newVal;
            store.commit('updatePersistentBookQuery', newVal);
            break;
          case 'guideline':
            guidelineQuery.value = newVal;
            store.commit('updatePersistentGuidelineQuery', newVal);
            break;
          case 'public-comment':
            publicCommentQuery.value = newVal;
            store.commit('updatePersistentPubcomQuery', newVal);
            break;
          case 'law':
            lawQuery.value = newVal;
            store.commit('updatePersistentLawQuery', newVal);
            break;
        }
      }
    });
    watch(storedQuery, function (newVal) {
      if (newVal === undefined) {
        return;
      }
      // キーワードは別で管理してているので除外
      var _keyword = newVal.keyword,
        filterQuery = _objectWithoutProperties(newVal, _excluded2);
      clonedQuery.value = filterQuery;
    }, {
      immediate: true
    });
    var searchConditionsString = computed(function () {
      var conditions = Object.entries(_objectSpread({
        keyword: inputSearchKeyword.value
      }, clonedQuery.value)).reduce(function (acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        if (value === undefined) {
          return acc;
        }
        if (key === 'type') {
          return acc;
        }
        if (key === 'maxGaps' && value === Constants.Search.NoMaxGaps) {
          acc.push('近傍検索オフ');
          return acc;
        }
        if (key === 'publishedOn' && _typeof(value) === 'object' && ('gte' in value || 'lte' in value) && (value.gte || value.lte)) {
          var _value$gte, _value$lte;
          acc.push("".concat((_value$gte = value.gte) !== null && _value$gte !== void 0 ? _value$gte : '', " ~ ").concat((_value$lte = value.lte) !== null && _value$lte !== void 0 ? _value$lte : ''));
          return acc;
        }
        if (Array.isArray(value)) {
          if (value.length === 0) {
            return acc;
          }
          acc.push(value.join(',　'));
          return acc;
        }
        if (typeof value === 'string' && value.trim().length > 0) {
          acc.push(value.trim());
          return acc;
        }
        return acc;
      }, []);
      return conditions.join(',　');
    });
    var variant = computed(function () {
      if (isCollapsed.value) {
        if (type.value === 'keyword' && (searchConditionsString === null || searchConditionsString === void 0 ? void 0 : searchConditionsString.value.length) > 0) {
          return 'collapsed_keyword_readonly';
        }
        return 'collapsed';
      }
      if (type.value === 'wandh') {
        return 'wandh';
      }
      if (showFilter.value) {
        switch (docType.value) {
          case 'book':
            return 'keyword_filter_book';
          case 'guideline':
            return 'keyword_filter_guideline';
          case 'public-comment':
            return 'keyword_filter_public-comment';
          case 'law':
            return 'keyword_filter_law';
        }
      }
      return 'keyword';
    });
    watch(variant, function (newVal) {
      emit('changeVariant', newVal);
    });
    var availableBooks = ref({
      store: [],
      other: WandhAvailableBooks
    });
    provide('availableBooks', availableBooks);
    var inputQuestion = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.question;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          question: newVal
        }));
      }
    });
    var inputQuery = computed(function () {
      var _store$state$persiste2, _store$state$persiste3;
      var filter = {};
      var publishedOnOrAfter = store.state.persistent.labs.wandh.inputQuery.filter.publishedOnOrAfterYear;
      if (typeof publishedOnOrAfter === 'number') {
        // 入力された値が数値の場合は年として扱う
        filter.publishedOnOrAfterYear = publishedOnOrAfter;
      }
      var documentType = store.state.persistent.labs.wandh.inputQuery.filter.documentType;
      filter.documentType = documentType;
      var genre = store.state.persistent.labs.wandh.inputQuery.filter.genre;
      if (genre.length) {
        filter.genre = genre;
      }

      // FIXME: API上でも { store: null, other: null } 的に送ってクエリログを短くできるべき
      //        いずれにせよlabs-wandh側でユーザーがアクセスできる書籍リストは取得・チェックしないといけないので、
      //        実装量はさほど増えない
      filter.id = [].concat(_toConsumableArray((_store$state$persiste2 = store.state.persistent.labs.wandh.inputQuery.filter.id.store) !== null && _store$state$persiste2 !== void 0 ? _store$state$persiste2 : availableBooks.value.store.map(function (book) {
        return book.naturalID;
      })), _toConsumableArray((_store$state$persiste3 = store.state.persistent.labs.wandh.inputQuery.filter.id.other) !== null && _store$state$persiste3 !== void 0 ? _store$state$persiste3 : availableBooks.value.other.map(function (book) {
        return book.naturalID;
      }))).sort();
      return {
        question: inputQuestion.value.trim(),
        selection: store.state.persistent.labs.wandh.inputQuery.selection,
        filter: filter
      };
    });
    var isWandhReady = computed(function () {
      return (
        // W&Hが動作中でない
        // (props.state === 'idle' || props.abortController) &&
        // 検索中でない
        !isSearching.value
      );
    });
    var isWandhAskable = computed(function () {
      var _searchForm$value, _wandhPanel$value, _agreementDialog$valu2;
      return ((_searchForm$value = searchForm.value) === null || _searchForm$value === void 0 ? void 0 : _searchForm$value.isWandhQuestionValid) && ((_wandhPanel$value = wandhPanel.value) === null || _wandhPanel$value === void 0 ? void 0 : _wandhPanel$value.isWandhFilterValid) && isWandhReady.value && ((_agreementDialog$valu2 = agreementDialog.value) === null || _agreementDialog$valu2 === void 0 ? void 0 : _agreementDialog$valu2.agreement);
    });
    provide('isWandhAskable', isWandhAskable);
    var isKeywordAskable = computed(function () {
      // ヘッダーの検索フォームでは詳細検索を選択した時、
      // キーワード指定なしでも検索結果を出したいので、
      // 何も条件を入力しなくても検索ボタンを押すことができる
      return inputSearchKeyword.value.trim().length > 0 || showFilter.value;
    });
    var ask = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!isWandhAskable.value || !inputQuery.value)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              isCollapsed.value = true;
              _context2.n = 2;
              return store.dispatch('startLoading');
            case 2:
              _context2.p = 2;
              isSearching.value = true;
              _context2.n = 3;
              return repositories.labs.preparePostLabsWandhQuestion(inputQuery.value);
            case 3:
              res = _context2.v;
              if (!(route.params.id === res.historyId)) {
                _context2.n = 4;
                break;
              }
              _context2.n = 4;
              return store.dispatch('endLoading');
            case 4:
              store.commit('setLabsWandhStreamParams', res);
              inputQuestion.value = '';
              telemetry.sendWandhAskTelemetry({
                action: 'ask',
                state: 'idle' // props.state,
              }, route);
              // Cookieにwandh初期化フラグを設定（5分有効）
              document.cookie = 'wandhInitialize=true; path=/; max-age=300';
              store.dispatch('endLoading');
              location.href = "/labs/wandh/q/".concat(res.historyId);
              _context2.n = 9;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              _context2.n = 6;
              return store.dispatch('endLoading');
            case 6:
              if (!(_t instanceof RateLimitError || _t instanceof QuotaExceededError)) {
                _context2.n = 7;
                break;
              }
              toast.error(_t.message);
              return _context2.a(2);
            case 7:
              if (!(_t instanceof Error)) {
                _context2.n = 8;
                break;
              }
              toast.error(_t.message);
              telemetry.sendErrorTelemetry(_t, route);
              throw _t;
            case 8:
              toast.error('予期せぬ問題が発生しました');
              telemetry.sendErrorTelemetry(new Error(String(_t)), route);
              throw new Error(String(_t));
            case 9:
              _context2.p = 9;
              isSearching.value = false;
              return _context2.f(9);
            case 10:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 5, 9, 10]]);
      }));
      return function ask() {
        return _ref5.apply(this, arguments);
      };
    }();
    var search = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var query, storedOption, to;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (isKeywordAskable.value) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              isCollapsed.value = true;
              _context3.n = 2;
              return store.dispatch('startLoading');
            case 2:
              // キーワード検索
              query = {
                keyword: inputSearchKeyword.value,
                type: [DocumentTypeEnum.Book],
                maxGaps: Constants.Search.DefaultMaxGaps,
                includeOlderEditions: false
              };
              if (showFilter.value) {
                query = _objectSpread(_objectSpread({}, query), clonedQuery.value);
              }
              storedOption = {
                n: store.state.persistent.perPage || Constants.Search.PerPage,
                o: store.state.search.orderId || Constants.Search.OrderId
              };
              to = generateSearchRoute(query, storedOption);
              if (!(JSON.stringify(to.query) === JSON.stringify(route.query))) {
                _context3.n = 3;
                break;
              }
              _context3.n = 3;
              return store.dispatch('endLoading');
            case 3:
              // 画面上部にスクロールする
              scrollToTop();
              store.commit('setSuggestionItems', []);
              router.push(to, function () {
                return store.dispatch('endLoading');
              });
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function search() {
        return _ref6.apply(this, arguments);
      };
    }();
    var filterReset = function filterReset() {
      if (type.value === 'wandh') {
        store.commit('setLabsWandhInputQueryInitialized', false);
        store.dispatch('initializeWandhInputQuery');
      } else {
        if (showFilter.value) {
          var resetQuery = {
            type: clonedQuery.value.type
          };
          clonedQuery.value = resetQuery;

          // Update the appropriate persistent store based on docType
          switch (docType.value) {
            case 'book':
              store.commit('updatePersistentBookQuery', resetQuery);
              break;
            case 'guideline':
              store.commit('updatePersistentGuidelineQuery', resetQuery);
              break;
            case 'public-comment':
              store.commit('updatePersistentPubcomQuery', resetQuery);
              break;
            case 'law':
              store.commit('updatePersistentLawQuery', resetQuery);
              break;
          }
          store.commit('setPerPage', Constants.Search.PerPage);
          store.commit('setSearchOrderId', Constants.Search.OrderId);
        }
      }
    };
    var submit = function submit() {
      if (type.value === 'wandh') {
        ask();
      } else {
        search();
      }
    };
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var res;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            repositories.users.purchasedDocuments(3000).then(function (docs) {
              availableBooks.value = _objectSpread(_objectSpread({}, availableBooks.value), {}, {
                store: docs.map(function (d) {
                  return {
                    naturalID: d.id,
                    title: d.title
                  };
                })
              });
            });
            _context4.n = 1;
            return repositories.labs.getLabsWandhQuota();
          case 1:
            res = _context4.v;
            store.commit('updateLabsWandhQuota', res);
            store.dispatch('initializeWandhInputQuery');
            if (store.state.persistent.search.keyword) {
              store.commit('setSearchKeyword', store.state.persistent.search.keyword);
            }
            bookQuery.value = _objectSpread({}, store.state.persistent.search.bookQuery);
            guidelineQuery.value = _objectSpread({}, store.state.persistent.search.guidelineQuery);
            publicCommentQuery.value = _objectSpread({}, store.state.persistent.search.pubcomQuery);
            lawQuery.value = _objectSpread({}, store.state.persistent.search.lawQuery);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    })));
    var collapse = function collapse() {
      isCollapsed.value = true;
    };
    expose({
      collapse: collapse
    });
    return {
      __sfc: true,
      emit: emit,
      toast: toast,
      isSearching: isSearching,
      repositories: repositories,
      store: store,
      telemetry: telemetry,
      route: route,
      router: router,
      type: type,
      docType: docType,
      isCollapsed: isCollapsed,
      showFilter: showFilter,
      showAgreementDialog: showAgreementDialog,
      searchForm: searchForm,
      wandhPanel: wandhPanel,
      agreementDialog: agreementDialog,
      inputSearchKeyword: inputSearchKeyword,
      isChangedFilterQuery: isChangedFilterQuery,
      storedQuery: storedQuery,
      toSearchDocType: toSearchDocType,
      fetchSuggestions: fetchSuggestions,
      debouncedFetchSuggestions: debouncedFetchSuggestions,
      handleClickSuggestion: handleClickSuggestion,
      suggestionItems: suggestionItems,
      handleChangeType: handleChangeType,
      handleChangeShowFilter: handleChangeShowFilter,
      handleChangeDocType: handleChangeDocType,
      handleShowDisclaimer: handleShowDisclaimer,
      bookQuery: bookQuery,
      guidelineQuery: guidelineQuery,
      publicCommentQuery: publicCommentQuery,
      lawQuery: lawQuery,
      clonedQuery: clonedQuery,
      searchConditionsString: searchConditionsString,
      variant: variant,
      availableBooks: availableBooks,
      inputQuestion: inputQuestion,
      inputQuery: inputQuery,
      isWandhReady: isWandhReady,
      isWandhAskable: isWandhAskable,
      isKeywordAskable: isKeywordAskable,
      ask: ask,
      search: search,
      filterReset: filterReset,
      submit: submit,
      collapse: collapse,
      SearchTabs: SearchTabs,
      SearchForm: SearchForm,
      BookPanel: BookPanel,
      GuidelinePanel: GuidelinePanel,
      PublicCommentPanel: PublicCommentPanel,
      LawPanel: LawPanel,
      WandhPanel: WandhPanel,
      SearchFooter: SearchFooter,
      AgreementDialog: AgreementDialog
    };
  }
});